export enum TerminologyType {
  Certification = 4
}